<template>
    <div>
        <table class="table table-bordered table-responsive-md">
            <thead>
                <tr>
                    <th class="text-center">{{ $t('imagetables') }}
                        <i style="float:right; padding-top:5px; cursor: pointer" @click="showAddImage()" class="fas fa-sm fa-plus"></i>
                    </th>
                </tr>
            </thead>
            <tbody v-if="list.length > 0">
                <tr v-for="(item, i) in list" :key="i">
                    <td >
                        <router-link :to="{ name: 'imagetabledetail', params: { id: item.id }}">
                            {{ item.name }}
                        </router-link>
                        <i style="float:right; padding-top:5px; cursor: pointer" @click="showDeleteImage(item)" class="fas fa-sm fa-trash"></i>
                    </td>
                </tr>
            </tbody>
        </table>
        <ImageTableDeleteDialog v-show="isModalVisible" @reload="requestData"></ImageTableDeleteDialog>
        <ImageTableAddDialog v-show="isAddImageVisible" @reload="requestData"></ImageTableAddDialog>
    </div>
</template>

<script>
import ImageApi from "../../../api/server/image";
import ImageTableDeleteDialog from "./ImageTableDeleteDialog.vue";
import ImageTableAddDialog from "./ImageTableAddDialog.vue";

export default {
    name: "images",
    components: {
        ImageTableDeleteDialog,
        ImageTableAddDialog
    },
    mounted() {
        this.requestData();
    },
    methods: {
        async requestData() {
            this.list = await ImageApi.imageTableList();
        },
        showDeleteImage(item) {
            this.imageToDeleteId = item.id
            this.imageToDeleteName = item.name
            this.isModalVisible = true
        },
        showAddImage() {
            this.isAddImageVisible = true;
        }
    },
    data() {
        return {
            imageToDeleteId: "",
            imageToDeleteName: "",
            isModalVisible: false,
            isAddImageVisible: false,
            list: []
        };
    },
};
</script>